import { getInstance } from '../../../common/api/spidertracks-sdk';
import { StandardThunk } from '../../../store';
import { AircraftTypeEnum, FlightDetail } from '../../../types/flyingPage';
import { setLatestFlightDetails, setLoading } from './flyingPage';
import { PrivateAircraftData } from '../../../common/api/spidertracks-sdk/types/AircraftData';
import { PrivateTrackData } from '../../../common/api/spidertracks-sdk/types/TrackData';
import { getIsActive } from '../tracks';
import { getTrackStatus } from '../../../components/Flying/AircraftList/utils/aircraftlistUtils';

function mapAircraftTypeToEnum(type: string | undefined): AircraftTypeEnum {
  switch (type) {
    case 'OTHER':
      return AircraftTypeEnum.OTHER;
    case 'FIXED_WING':
      return AircraftTypeEnum.FIXED_WING;
    case 'ROTARY_WING':
      return AircraftTypeEnum.ROTARY;
    default:
      return AircraftTypeEnum.UNDEFINED;
  }
}

export const fetchLatestFlightDetails = (organisationSlug: string): StandardThunk<void> => async (
  dispatch,
  getState
) => {
  const sdk = getInstance();
  const aircrafts = (await sdk.getAircraft(organisationSlug)) as PrivateAircraftData[];
  // TODO: optimize points fetched count later.
  const latestTrack = (await sdk.getLatestTracks(organisationSlug, 10000)) as PrivateTrackData[];
  const latestFlightDetails: FlightDetail[] = latestTrack
    .map(track => {
      const aircraft = aircrafts.find(aircraft => aircraft.id === track.aircraft.id);
      if (aircraft) {
        return {
          aircraftId: aircraft.id,
          aircraft: {
            registration: aircraft.registration,
            type: mapAircraftTypeToEnum(aircraft.type),
            isActive: getIsActive(track.points),
            trackStatus: getTrackStatus(track.state, getIsActive(track.points)),
            aircraftIcon: aircraft.aircraft_icon,
            aircraftIconColor: aircraft.aircraft_icon_colour
          },
          activeDeviceConnection: track.aircraft.activeDeviceConnection ?? undefined,
          track: track
        };
      }
    })
    .filter(flightDetail => flightDetail !== undefined) as FlightDetail[];

  dispatch(setLatestFlightDetails(latestFlightDetails));
  dispatch(setLoading(false));
};
